module.exports = __webpack_public_path__ + "img/yaoxing2.4ca0b9b3.png";